var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnToHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11568_22641",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V19.9999H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11568_22641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 5.25488L2.86701 11.1352C2.86701 11.1435 2.86492 11.1557 2.86075 11.1723C2.85666 11.1888 2.85449 11.2008 2.85449 11.2093V17.1638C2.85449 17.3788 2.93309 17.5651 3.09025 17.722C3.24737 17.879 3.43342 17.958 3.64846 17.958H8.41188V13.1943H11.5879V17.9582H16.3514C16.5664 17.9582 16.7527 17.8793 16.9096 17.722C17.0667 17.5653 17.1456 17.3788 17.1456 17.1638V11.2093C17.1456 11.1763 17.1411 11.1514 17.1331 11.1352L9.99988 5.25488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.862 9.79542L17.1454 7.53764V2.47628C17.1454 2.36057 17.1082 2.26541 17.0336 2.19094C16.9596 2.11655 16.8644 2.07936 16.7484 2.07936H14.3666C14.2509 2.07936 14.1557 2.11655 14.0812 2.19094C14.0069 2.26541 13.9697 2.36061 13.9697 2.47628V4.89527L10.9429 2.36452C10.6786 2.14949 10.3642 2.04199 10.0003 2.04199C9.63636 2.04199 9.32214 2.14949 9.0575 2.36452L0.137848 9.79542C0.0551624 9.86142 0.00984393 9.95035 0.00141463 10.062C-0.00697124 10.1736 0.0219231 10.2711 0.0881843 10.3537L0.857293 11.2717C0.923557 11.3461 1.01029 11.3916 1.11782 11.4082C1.21711 11.4166 1.31639 11.3876 1.41567 11.3214L10 4.16336L18.5844 11.3213C18.6508 11.3791 18.7374 11.4078 18.845 11.4078H18.8823C18.9896 11.3916 19.0762 11.3458 19.1428 11.2716L19.912 10.3536C19.9781 10.2708 20.0071 10.1736 19.9985 10.0618C19.99 9.95049 19.9446 9.86156 19.862 9.79542Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnToHead);
export default __webpack_public_path__ + "static/media/return-to-head.80114fb4d43d2245ac1597711faf7157.svg";
export { ForwardRef as ReactComponent };